import { localize } from "@gtmhub/localization";
import { IComponentOptions, IController } from "angular";
import { QuerySessionsService } from "@gtmhub/customFields/services/query-sessions.service";
import { ISessionSelectorDataLoader } from "./models";
import { ISessionTag } from "@gtmhub/customFields/models/models";
import { ICustomField } from "@gtmhub/customFields";
import { ITraceRootScopeService } from "@gtmhub/core/tracing";

/**
 * Provides functionality for selecting sessions form a drop down list of all active sessions
 *
 * `custom-field` the custom field for which sessions are being added.
 * `session-tags` session tags.
 *
 * @example
 * <session-selector
 *   custom-field="$ctrl.customField"
 *   session-tags="$ctrl.sessionTags"
 * </session-selector>
 */

export class SessionSelectorComponentCtrl implements IController {
  // bindings
  customField: ICustomField;
  sessionTags: ISessionTag[];

  maxUnfocusedSessionTags = 4;
  sessionSearchParams: ISessionSelectorDataLoader;

  public static $inject = ["$rootScope", "QuerySessionsService"];

  constructor(private $rootScope: ITraceRootScopeService, private querySessionsService: QuerySessionsService) {}

  $onInit(): void {
    this.sessionSearchParams = this.createSessionSearchSessionTagsParams();
  }

  private createSessionSearchSessionTagsParams(): ISessionSelectorDataLoader {
    return {
      placeholder: localize("search_for_session"),
      query: this.querySessionsService.querySessions.bind(this.querySessionsService),
    };
  }

  addSessionIdToCustomField(sessionId: string): void {
    this.$rootScope.traceAction("add_session_to_custom_field", () => {
      if (!this.customField.targetIds) {
        this.customField.targetIds = [];
        this.customField.operationalType = "global";
      }
      if (this.customField.targetIds.length == 0) {
        this.customField.operationalType = "session";
      }
      this.customField.targetIds.push(sessionId);
      if (!this.sessionTags.find((sessionTag) => sessionTag.id === sessionId)) {
        const sessionTag = this.querySessionsService.createSessionTag(sessionId);
        this.sessionTags.push(sessionTag);
      }
    });
  }

  removeSessionIdFromCustomField(sessionId: string): void {
    this.$rootScope.traceAction("remove_session_from_custom_field", () => {
      this.customField.targetIds = this.customField.targetIds.filter((session) => {
        return session !== sessionId;
      });

      if (this.customField.targetIds.length == 0) {
        this.customField.operationalType = "global";
        this.customField.targetIds = [];
      }

      this.sessionTags.forEach((sessionTag) => {
        if (sessionTag.id === sessionId) {
          this.sessionTags = this.sessionTags.filter((sessionTag) => sessionTag.id !== sessionId);
        }
      });
    });
  }
}

export const SessionSelectorComponent: IComponentOptions = {
  templateUrl: require("./session-selector.jade"),
  controller: SessionSelectorComponentCtrl,
  bindings: {
    customField: "<",
    sessionTags: "<",
  },
};
